module.exports = __webpack_public_path__ + "img/march-2.fba0a2dc.jpg";